import { lazy } from 'react';
export const NotFound = lazy(() => import('@project/routes/pages/NotFound'));

export const NotFoundRoutes = () => {
  return <NotFound />;
};
